<template>
    <div class="container-outline">
        <div class="register">
            <div class="title">Register Preview</div>
            <div class="top-squence">
                <ul>
                    <li class="li-active">
                        <div class="squnce-active">1</div>
                        <span>Profil Pialang</span>
                    </li>
                    <li class="li-active">
                        <div class="squnce-active">2</div>
                        <span>Simulasi</span>
                    </li>
                    <li class="li-active">
                        <div class="squnce-active">3</div>
                        <span>Pengalaman Transaksi</span>
                    </li>
                    <li class="li-active">
                        <div class="squnce-active">4</div>
                        <span>Data Pribadi</span>
                    </li>
                    <li class="li-active">
                        <div class="squnce-active">5</div>
                        <span>Kontak Darurat</span>
                    </li>
                    <li class="li-active">
                        <div class="squnce-active">6</div>
                        <span>Pekerjaan</span>
                    </li>
                    <li class="li-active">
                        <div class="squnce-active">7</div>
                        <span>Kekayaan</span>
                    </li>
                    <li class="li-active">
                        <div class="squnce-active">8</div>
                        <span>Rekening Nasabah</span>
                    </li>
                    <li class="li-active">
                        <div class="squnce-active">9</div>
                        <span>Lampiran</span>
                    </li>
                    <li class="li-active">
                        <div class="squnce-active">10</div>
                        <span>Resiko</span>
                    </li>
                    <li class="li-active">
                        <div class="squnce-active">11</div>
                        <span>Amanat</span>
                    </li>
                    <li class="li-active">
                        <div class="squnce-active">12</div>
                        <span>Kode Akses</span>
                    </li>
                </ul>
            </div>
            <div class="content-register">
                <div class="centent-review">
                    <div class="container">
                        <p class="sub-sub-title">Identitas Pengguna</p>
                        <div class="form-group">
                            <label for="">Nama Lengkap</label>
                            <span>{{ dataPribadi.fullname }}</span>
                        </div>
                        <div class="form-group">
                            <label for="">Tempat/ tanggal lahir</label>
                            <span>{{ dataPribadi.place_of_birth }}, </span>
                            <span>{{ dataPribadi.date_of_birth | formatDate }}</span>
                        </div>
                        <div class="form-group">
                            <label for="">Alamat sesuai KTP</label>
                            <span>{{ dataPribadiIdentity.address }}</span>
                        </div>
                        <div class="form-group">
                            <label class="detail-alamat">Provinsi</label>
                            <span>{{ dataPribadiIdentity.province }}</span>
                        </div>
                        <div class="form-group">
                            <label class="detail-alamat">Kota</label>
                            <span>{{ dataPribadiIdentity.regency }}</span>
                        </div>
                        <div class="form-group">
                            <label class="detail-alamat">Kecamatan</label>
                            <span>{{ dataPribadiIdentity.district }}</span>
                        </div>
                        <div class="form-group">
                            <label class="detail-alamat">Kelurahan</label>
                            <span>{{ dataPribadiIdentity.village }}</span>
                        </div>
                        <div class="form-group">
                            <label class="detail-alamat">RT/RW </label>
                            <span>{{ dataPribadiIdentity.neighborhood_no }} / {{ dataPribadiIdentity.citizen_no }}</span>
                        </div>
                        <div class="form-group">
                            <label class="detail-alamat">Kodepos</label>
                            <span>{{ dataPribadiIdentity.postcode }}</span>
                        </div>
                        <div class="form-group">
                            <label for="">NPWP</label>
                            <span>{{ dataPribadi.npwp_no }}</span>
                        </div>
                        <div class="form-group">
                            <label for="">No Telepon Rumah</label>
                            <span>{{ dataPribadiIdentity.telephone }}</span>
                        </div>
                        <div class="form-group">
                            <label for="">Jenis Kelamin</label>
                            <span>{{ dataPribadi.gender_type ? dataPribadi.gender_type.name : "" }}</span>
                        </div>
                        <div class="form-group">
                            <label for="">No Identitas</label>
                            <span>( KTP ) {{ dataPribadi.ktp_no }}</span>
                        </div>
                        <div class="form-group">
                            <label for="">Setatus Perkawinan</label>
                            <span>{{ dataPribadi.marriage_type ? dataPribadi.marriage_type.name : "" }}</span>
                        </div>
                        <div class="form-group">
                            <label for="">Nama suami/istri(Opsional)</label>
                            <span>{{ dataPribadi.partners_name ? dataPribadi.partners_name : "-" }}</span>
                        </div>
                        <div class="form-group">
                            <label for="">Nama ibu kandung</label>
                            <span>{{ dataPribadi.mothers_name }}</span>
                        </div>
                        <div class="form-group">
                            <label for="">Status Kepimilikan Rumah</label>
                            <span>{{ dataPribadiIdentity.ownership_status }}</span>
                        </div>
                        <div class="form-group">
                            <label for="">Tujuan pembukaan rekening</label>
                            <span>{{ dataPribadi.purpose_open_account_type ? dataPribadi.purpose_open_account_type.name : "" }}</span>
                        </div>
                        <div class="form-group">
                            <label for="">Pengalaman Investasi</label>
                            <span>{{ dataPribadi.has_investment_experience ? "Pernah" : "Tidak" }}</span>
                        </div>

                        <div class="form-group header-title" v-b-toggle.multiCollapseExample2>
                            <p class="sub-sub-title">Data Pekerjaan <span class="arrow-down pull-right" /></p>
                        </div>
                        <b-collapse id="multiCollapseExample2">
                            <div class="form-group">
                                <label for="">Pekerjaan</label>
                                <span v-if="dataEmployment.occupation_type">
                                    {{ dataEmployment.occupation_type.code == 7 ? dataEmployment.other_occupation : dataEmployment.occupation_type.name }}
                                </span>
                            </div>
                            <div class="form-group">
                                <label for="">Nama perusahaan</label>
                                <span>{{ dataEmployment.company_name }}</span>
                            </div>
                            <div class="form-group">
                                <label for="">Bidang usaha</label>
                                <span>{{ dataEmployment.business_sector }}</span>
                            </div>
                            <div class="form-group">
                                <label for="">Jabatan</label>
                                <span>{{ dataEmployment.other_position }}</span>
                            </div>
                            <div class="form-group">
                                <label for="">Lama pekerjaan</label>
                            </div>
                            <div class="form-group">
                                <label class="detail-alamat">Saat ini</label>
                                <span>{{ dataEmployment.work_year }}</span>
                                <span class="tahun">Tahun</span>
                                <span>{{ dataEmployment.work_month }}</span>
                                <span class="tahun">Bulan</span>
                            </div>
                            <div class="form-group">
                                <label class="detail-alamat">Perusahaan sebelumnya</label>
                                <span>{{ dataEmployment.work_year_previous }}</span>
                                <span class="tahun">Tahun</span>
                            </div>
                            <div class="form-group">
                                <label for="">Alamat Perusahaan</label>
                                <span>{{ dataEmployment.company_address ? dataEmployment.company_address.address : "" }}</span>
                            </div>
                            <div class="form-group">
                                <label class="detail-alamat">Provinsi</label>
                                <span>{{ dataEmployment.company_address ? dataEmployment.company_address.province : "" }}</span>
                            </div>
                            <div class="form-group">
                                <label class="detail-alamat">Kota</label>
                                <span>{{ dataEmployment.company_address ? dataEmployment.company_address.regency : "" }}</span>
                            </div>
                            <div class="form-group">
                                <label class="detail-alamat">Kecamatan</label>
                                <span>{{ dataEmployment.company_address ? dataEmployment.company_address.district : "" }}</span>
                            </div>
                            <div class="form-group">
                                <label class="detail-alamat">Kelurahan</label>
                                <span>{{ dataEmployment.company_address ? dataEmployment.company_address.village : "" }}</span>
                            </div>
                            <div class="form-group">
                                <label class="detail-alamat">RT/RW </label>
                                <span
                                    >{{ dataEmployment.company_address ? dataEmployment.company_address.neighborhood_no : "" }} /
                                    {{ dataEmployment.company_address ? dataEmployment.company_address.citizen_no : "" }}</span
                                >
                            </div>
                            <div class="form-group">
                                <label>Kodepos</label>
                                <span>{{ dataEmployment.company_address ? dataEmployment.company_address.postcode : "" }}</span>
                            </div>
                            <div class="form-group">
                                <label>No Telepon perusahaan</label>
                                <span>{{ dataEmployment.company_address ? dataEmployment.company_address.telephone : "" }}</span>
                            </div>
                            <div class="form-group">
                                <label>No faksimail perusahaan(opsional)</label>
                                <span>{{ dataEmployment.company_address ? dataEmployment.company_address.fax : "" }}</span>
                            </div>
                        </b-collapse>

                        <div class="form-group" v-b-toggle.dataKeuangan>
                            <p class="sub-sub-title">
                                Data Keuangan dan transaksi
                                <span class="arrow-down pull-right" />
                            </p>
                        </div>
                        <b-collapse id="dataKeuangan">
                            <div class="form-group">
                                <label for="">Penghasilan pertahun</label>
                                <span>{{ dataFinancial.salary_type ? dataFinancial.salary_type.name : "" }}</span>
                            </div>
                            <div class="form-group">
                                <label for="">Lokasi rumah</label>
                                <span>{{ dataFinancial.wealth_list ? dataFinancial.wealth_list.home_location : "" }}</span>
                            </div>
                            <div class="form-group">
                                <label for="">Nilai NJOP</label>
                                <span>{{ dataFinancial.wealth_list ? currencyFormat(dataFinancial.wealth_list.njop_value) : "" }}</span>
                            </div>
                            <div class="form-group">
                                <label for="">Deposit Bank</label>
                                <span>{{ dataFinancial.wealth_list ? dataFinancial.wealth_list.deposit : "" }}</span>
                            </div>
                            <div class="form-group">
                                <label for="">Jumlah</label>
                                <span>{{ dataFinancial.wealth_list ? currencyFormat(dataFinancial.wealth_list.total_deposit) : "" }}</span>
                            </div>
                            <div class="form-group">
                                <label for="">Lainnya</label>
                                <span>{{ dataFinancial.wealth_list ? dataFinancial.wealth_list.other : "" }}</span>
                            </div>
                        </b-collapse>

                        <div class="form-group" v-b-toggle.rekeningNasabah>
                            <p class="sub-sub-title">Rekening Nasabah <span class="arrow-down pull-right" /></p>
                        </div>
                        <b-collapse id="rekeningNasabah">
                            <div>
                                <div class="form-group">
                                    <label>Nama bank</label>
                                    <span>{{ dataCustomer[0] ? dataCustomer[0].name : "" }}</span>
                                </div>
                                <div class="form-group">
                                    <label>No Rekening</label>
                                    <span>{{ dataCustomer[0] ? dataCustomer[0].account_no : "" }}</span>
                                </div>
                                <div class="form-group">
                                    <label>Cabang</label>
                                    <span>{{ dataCustomer[0] ? dataCustomer[0].branch : "" }}</span>
                                </div>
                                <div class="form-group">
                                    <label>Telepon</label>
                                    <span>{{ dataCustomer[0] ? dataCustomer[0].phonenumber : "" }}</span>
                                </div>
                                <div class="form-group">
                                    <label>Jenis Rekening</label>
                                    <span>{{ dataCustomer[0] ? dataCustomer[0].type_account : "" }}</span>
                                </div>
                            </div>
                        </b-collapse>

                        <div class="form-group" v-b-toggle.kontakDarurat>
                            <p class="sub-sub-title">Kontak darurat <span class="arrow-down pull-right" /></p>
                        </div>
                        <b-collapse id="kontakDarurat">
                            <div class="form-group">
                                <label for="">Nama</label>
                                <span>{{ dataEmergency.fullname }}</span>
                            </div>
                            <div class="form-group">
                                <label for="">Alamat</label>
                                <span>{{ dataEmergency.address }}</span>
                            </div>
                            <div class="form-group">
                                <label>Kodepos</label>
                                <span>{{ dataEmergency.postcode }}</span>
                            </div>
                            <div class="form-group">
                                <label>No Telepon</label>
                                <span>{{ dataEmergency.phonenumber }}</span>
                            </div>
                            <div class="form-group">
                                <label for="">Hubungan anda</label>
                                <span>{{ dataEmergency.relationship }}</span>
                            </div>
                        </b-collapse>
                        <div class="form-group" v-b-toggle.lampiran>
                            <p class="sub-sub-title">Lampiran <span class="arrow-down pull-right" /></p>
                        </div>
                        <b-collapse id="lampiran">
                            <div class="form-group lampiran">
                                <div>
                                    <p>
                                        Foto Rekening Koran Bank / <br />
                                        Tagihan Kartu Kredit
                                    </p>
                                    <img :src="dataImages.rekBank" alt="" />
                                </div>
                                <div>
                                    <p>Foto Rekening Listrik / Telepon</p>
                                    <img :src="dataImages.rekListrik" alt="" />
                                </div>
                                <div>
                                    <p>Foto KTP</p>
                                    <img :src="dataImages.ktp" alt="" />
                                </div>
                                <div>
                                    <p>Foto NPWP</p>
                                    <img :src="dataImages.npwp" alt="" />
                                </div>
                                <div>
                                    <p>Foto Terkini</p>
                                    <img :src="dataImages.photo" alt="" />
                                </div>
                                <div>
                                    <p>Foto diri dengan KTP</p>
                                    <img :src="dataImages.photo_ktp" alt="" />
                                </div>
                                <div>
                                    <p>Foto Kartu Keluarga</p>
                                    <img :src="dataImages.kk" alt="" />
                                </div>
                                <div>
                                    <p>Tanda Tangan</p>
                                    <img :src="dataImages.signature" alt="" />
                                </div>
                                <div>
                                    <p>Video Verifikasi</p>
                                    <div class="text-center" v-if="isLoadVideo">
                                        <b-spinner size="xl"></b-spinner>
                                    </div>
                                    <video v-else playsinline controls>
                                        <source :src="dataImages.video_statement" type="video/mp4" />
                                        <source :src="dataImages.video_statement" type="video/ogv" />
                                        <source type="video/webm" :src="dataImages.video_statement" />
                                    </video>
                                </div>
                            </div>
                        </b-collapse>

                        <div class="error" v-show="message == 400">
                            Pastikan data anda sudah terisi semua
                        </div>
                        <div class="button">
                            <router-link to="/kode-akses"><button class="btn-scondary">Sebelumnya</button></router-link>
                            <router-link to="/verification-page">
                                <button class="btn-primer">
                                    Selanjutnya
                                </button>
                            </router-link>

                            <b-modal id="modal-1" title="Pernyataan">
                                <h5 class="text-center">Dengan ini saya menyatakan bahwa tidak akan memberitahukan kode akses kepihak manapun</h5>
                                <template #modal-footer>
                                    <button class="btn-primer" @click="nextStep" :disabled="!statementUser">
                                        <div v-show="loading == false">Submit</div>
                                        <Loader class="loading" v-show="loading" />
                                    </button>
                                </template>
                            </b-modal>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
// import moment from 'moment'
import Loader from "../assets/Loading";

export default {
    components: {
        Loader,
    },
    data() {
        return {
            form: {
                kyc: 1,
                flag_register: 1,
            },
            isLoadVideo: false,
            dataEmergency: [],
            dataCustomer: [],
            dataFinance: [],
            dataFinancial: [],
            dataWork: [],
            dataEmployment: [],
            dataPribadi: [],
            dataPribadiCustomer: [],
            dataPribadiIdentity: [],
            dataPribadiDomicili: [],
            identityProvince: "",
            identityRegency: "",
            identityDistrict: "",
            identityVillage: "",
            domiciliProvince: "",
            domiciliRegency: "",
            domiciliDistrict: "",
            domiciliVillage: "",
            gender: "",
            religion: "",
            marrige: "",
            dataAttachment: [],
            dataAll: [],
            identity: "",
            loading: false,
            message: "",
            typeRek: "",
            platform: "",
            idDataSubmit: "",
            dataImages: {
                rekBank: "",
                rekListrik: "",
                ktp: "",
                photo: "",
                photo_ktp: "",
                signature: "",
                video_statement: "",
                kk: "",
                npwp: "",
            },
            currentDate: "",
            statementUser: Boolean,
            baseUrl: axios.defaults.baseURL,
        };
    },
    mounted() {
        this.currentDate = new Date();
        this.platform = localStorage.getItem("platform");
        let bank = localStorage.getItem("code");
        if (bank == 1) {
            this.typeRek = "Konfensional";
        } else if (bank == 2) {
            this.typeRek = "Umum";
        } else if (bank == 4) {
            this.typeRek = "Syariah";
        } else {
            this.bank_rdk = "OCBC Bank";
        }
        this.$store.dispatch("getCustomer").then((res) => {
            this.dataPribadi = res;
            this.dataPribadiIdentity = res.identity_address;
            this.dataPribadiDomicili = res.domicile_address;
            axios.get("/v2/kyc/financial/" + res._id).then((resfin) => {
                this.dataFinancial = resfin.data.data.financial;
            });
            axios.get("/v2/kyc/employment/" + res._id).then((resemp) => {
                this.dataEmployment = resemp.data.data.employment;
            });
            axios.get("/v2/kyc/bank/account/" + res._id).then((resacc) => {
                this.dataCustomer = resacc.data.data.customer.bank_account;
            });
            axios.get("/v2/kyc/emergency_contact/" + res._id).then((reseme) => {
                this.dataEmergency = reseme.data.data.emergency_contact;
            });
            axios.get("/v2/kyc/attachment/" + res._id).then((resatch) => {
                this.dataAttachment = resatch.data.data.attachment;
                this.isLoadVideo = true;
                this.getUrlBlob(this.dataAttachment.statement_video).then((res) => {
                    this.dataImages.video_statement = res;
                    this.isLoadVideo = false;
                });

                // this.$store.dispatch("getVideo", this.dataAttachment.statement_video).then((res) => {
                //     let blob = new Blob([res], { type: "video/mp4" });
                //     let url = URL.createObjectURL(blob);
                //     let videoElement = document.getElementById("videoPlayer");
                //     videoElement.src = url;
                //     this.dataImages.video_statement = url;
                //     console.log(this.dataImages.video_statement);
                //     this.isLoadVideo = false;
                // });
                this.$store.dispatch("getImageAccess", this.dataAttachment.bank_statement).then((res) => {
                    this.dataImages.rekBank = res;
                });
                this.$store.dispatch("getImageAccess", this.dataAttachment.other).then((res) => {
                    this.dataImages.rekListrik = res;
                });
                this.$store.dispatch("getImageAccess", this.dataAttachment.ktp).then((res) => {
                    this.dataImages.ktp = res;
                });
                this.$store.dispatch("getImageAccess", this.dataAttachment.photo).then((res) => {
                    this.dataImages.photo = res;
                });
                this.$store.dispatch("getImageAccess", this.dataAttachment.photo_with_ktp).then((res) => {
                    this.dataImages.photo_ktp = res;
                });
                this.$store.dispatch("getImageAccess", this.dataAttachment.signature).then((res) => {
                    this.dataImages.signature = res;
                });
                this.$store.dispatch("getImageAccess", this.dataAttachment.kk).then((res) => {
                    this.dataImages.kk = res;
                });
                this.$store.dispatch("getImageAccess", this.dataAttachment.npwp).then((res) => {
                    this.dataImages.npwp = res;
                });
                // this.isLoadVideo = true;
                // axios.get("/v2/get/file" + this.dataAttachment.statement_video, { responseType: "arraybuffer" }).then((res) => {
                //     const base64 = btoa(new Uint8Array(res.data).reduce((data, byte) => data + String.fromCharCode(byte), ""));
                //     const byteCharacters = atob(base64);
                //     let sliceSize = 512;
                //     const byteArrays = [];

                //     for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                //         const slice = byteCharacters.slice(offset, offset + sliceSize);
                //         const byteNumbers = new Array(slice.length);
                //         for (let i = 0; i < slice.length; i++) {
                //             byteNumbers[i] = slice.charCodeAt(i);
                //         }
                //         const byteArray = new Uint8Array(byteNumbers);
                //         byteArrays.push(byteArray);
                //     }

                //     const blob = new Blob(byteArrays, { type: "video/mp4" });
                //     const blobUrl = URL.createObjectURL(blob);
                //     this.dataImages.video_statement = blobUrl;
                //     this.isLoadVideo = false;
                // });
            });
        });
    },
    computed: {
        customerId() {
            return this.$store.getters.customerData._id;
        },
    },
    methods: {
        async getUrlBlob(val) {
            if (val) {
                let base_url = axios.defaults.baseURL;
                const sig_url = base_url + "/v2/get/file" + val;
                const token = localStorage.getItem("token");
                const sigRequest = await fetch(sig_url, {
                    method: "GET", // or 'PUT'
                    headers: {
                        authorization: "Bearer " + token,
                    },
                });
                // console.log(sigRequest.url);
                const blob = await sigRequest.blob();
                const newUrl = URL.createObjectURL(blob);
                return newUrl;
            }
        },
        currencyFormat(value) {
            return (value + "").replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
        nextStep() {
            this.$router.push("/verification-page");
        },
        registerKyc() {
            this.loading = true;
            axios
                .patch("/v2/kyc/submission/" + this.customerId)
                .then((res) => {
                    let status = res.data.data.status_code;
                    if (status == "00") {
                        this.$router.push("/register-waiting");
                        this.loading = false;
                    } else if (status == "2005") {
                        this.isLoading = false;
                        this.$notify({
                            group: "foo",
                            title: "<h5>Silahkan lengkapi Data Pribadi</h5>",
                            type: "error",
                            duration: 2000,
                        });
                    } else if (status == "2006") {
                        this.isLoading = false;
                        this.$notify({
                            group: "foo",
                            title: "<h5>Silahkan lengkapi Data Pekerjaan</h5>",
                            type: "error",
                            duration: 2000,
                        });
                    } else if (status == "2007") {
                        this.isLoading = false;
                        this.$notify({
                            group: "foo",
                            title: "<h5>Silahkan lengkapi Data Keuangan</h5>",
                            type: "error",
                            duration: 2000,
                        });
                    } else if (status == "2008") {
                        this.isLoading = false;
                        this.$notify({
                            group: "foo",
                            title: "<h5>Silahkan lengkapi Data Kontak Darurat</h5>",
                            type: "error",
                            duration: 2000,
                        });
                    } else if (status == "2009") {
                        this.isLoading = false;
                        this.$notify({
                            group: "foo",
                            title: "<h5>Silahkan lengkapi Data Lampiran</h5>",
                            type: "error",
                            duration: 2000,
                        });
                    } else {
                        this.$notify({
                            group: "foo",
                            title: "<h5>kesalahan sistem</h5>",
                            type: "error",
                            duration: 2000,
                        });
                    }
                })
                .catch((error) => {
                    this.message = error.response.status;
                    this.loading = false;
                });
        },
    },
};
</script>

<style scoped>
.container-outline {
    width: 70%;
}

.container {
    width: 90%;
    padding-top: 45px;
}

.arrow-down {
    border: solid #1f354a;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 4px;
    transform: rotate(45deg);
}

.form-group span {
    font-size: 14px;
    text-transform: lowercase;
    display: inline-block;
}

.form-group label {
    text-transform: capitalize;
}

.form-group span::first-letter,
.form-group span::first-line {
    text-transform: capitalize;
}

.sub {
    font-weight: bold;
    margin: 20px 0;
    font-size: 15px;
}

.centent-review {
    border-radius: 15px;
    /* border: solid 1px rgba(112, 112, 112, 0.25); */
    padding: 15px 0;
    margin-bottom: 75px;
}

.label-radio {
    width: 185px;
    cursor: pointer;
}

input[type="file"] {
    border: none;
}

.input-file {
    /* visibility: hidden; */
    /* display: none; */
    opacity: 0;
    cursor: pointer;
    vertical-align: middle;
    /* border: solid 1px #000e22; */
}

/* .input-file{
    background: transparent;
    width: 73%;
    vertical-align: middle;
} */

.lampiran {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 1rem;
}

.lampiran div {
    margin: 0 5px;
}

.lampiran div img {
    width: 150px;
}

.lampiran div video {
    width: 260px;
}

.lampiran div p {
    text-align: center;
    margin-bottom: 0.2rem;
}

.error {
    border: 1px solid;
    border-radius: 5px;
    text-align: center;
}

.label-upload {
    position: absolute;
    left: 247px;
    width: 73%;
    height: 50px;
    border-radius: 10px;
    padding: 15px 20px;
    border: solid 1px #707070;
    color: rgba(112, 112, 112, 0.5);
    z-index: -1;
    background-color: none;
}

.input-file ~ .label-upload:focus {
    color: #707070;
    background-color: #fff;
    border-color: #1f354a !important;
    outline: 0;
    z-index: 3;
    box-shadow: 0 0 0 0.3rem rgba(100, 84, 240, 0.25);
}

.label-upload::after {
    content: attr(data-browse);
    position: absolute;
    right: 0px;
    top: 0px;
    border-top-right-radius: 9px;
    border-bottom-right-radius: 9px;
    padding: 13px 30px;
    background: #1f354a;
    height: 22px;
    width: 90px;
    text-align: center;
    color: white;
    border-left: inherit;
    font-size: 14px;
}

.outer {
    margin: 10px 25px 10px 15px;
}

.register {
    margin: 46px 0;
}

label {
    font-size: 14px;
    width: 260px;
    display: inline-block;
}

.detail-alamat {
    width: 230px;
    margin: 0 0 0 30px;
}

.form-input {
    width: 73%;
    height: 50px;
    border-radius: 10px;
    border: solid 1px #707070;
}

.placholder {
    position: absolute;
    left: 270px;
    top: 15px;
    font-size: 14px;
    color: rgba(112, 112, 112, 0.5);
}

.placholder::after {
    content: "upload file";
}

select {
    width: 73%;
    height: 50px;
    border-radius: 10px;
    border: solid 1px #707070;
}

.tempat {
    width: 41%;
    margin: 0 25px 0 0;
}

.tanggal {
    width: 25%;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
}

.pos-telepon {
    width: 25%;
}

.jabatan {
    height: 35px;
    width: 10%;
}

.tahun {
    margin: 0 20px 0 10px;
}

.identitas {
    width: 20%;
    margin: 0 32px 0 0;
    background-position-x: 88%;
}

.no-identitas {
    width: 50%;
}

.input-button {
    width: 50px;
    height: 50px;
    text-align: center;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    position: relative;
    top: 6px;
    left: -1px;
    border: solid 1px #707070;
    background-color: #1f354a;
    border-bottom-right-radius: 10px;
    border-top-right-radius: 10px;
}

.icon-calender {
    font-size: 20px;
    color: white;
}

.content-register {
    box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15);
    background: #ffffff;
    border-radius: 5px;
}

.title {
    font-size: 25px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    margin: 0 0 50px;
}

.navigation {
    margin: 0 0 50px;
    font-size: 10px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
}
.container {
    width: 90%;
    /* padding: 20px 30px; */
}

.nav-root {
    display: flex;
    justify-content: space-between;
    margin: 0 0 50px;
    position: relative;
    /* background-color: lightcyan; */
}

.list-root {
    list-style: none;
    height: 65px;
    width: 40%;
    padding: 20px 15px;
    color: rgba(139, 77, 77, 0.5);
    text-align: center;
}

.active {
    border-top-right-radius: 30px;
    border-bottom-right-radius: 30px;
    border-top: solid 2px #000e22;
    border-right: solid 2px #000e22;
    border-bottom: solid 2px #000e22;
    background-color: #1f354a;
    color: white;
    position: relative;
    text-align: center;
}

.active:first-child {
    border-top-left-radius: 15px;
}

.active:last-child {
    border-top-right-radius: 15px;
    border-bottom-right-radius: 0;
}

.active::before {
    z-index: -1;
    position: absolute;
    content: "";
    display: inline-block;
    width: 50px;
    height: 65px;
    background-color: #1f354a;
    top: -2px;
    left: -41px;
    border: 2px solid #000e22;
}

.active:first-child::before {
    opacity: 0;
}

.button {
    display: flex;
    justify-content: space-between;
    padding: 76px 15px;
}

.sub-title {
    margin: 0 0 73px;
    font-size: 18px;
    font-weight: bold;
}

.arrow {
    margin-left: 10px;
    margin-right: 10px;
    border: solid #1f354a;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 4px;
    transform: rotate(45deg);
    vertical-align: super;
}

.wrap-arrow {
    position: absolute;
    display: inline-block;
    width: 56px;
    height: 48px;
    /* border: solid 1px; */
    right: 50px;
    top: 1px;
    border-radius: 10px;
    text-align: center;
    padding: 15px 9px;
    background: white;
}

.sub-sub-title {
    font-size: 18px;
    font-weight: bold;
    margin: 0 0 30px;
    cursor: pointer;
}

.img {
    float: right;
    text-align: center;
}

.img-user {
    margin-bottom: 55px;
    width: 165.2px;
    height: 194px;
    object-fit: contain;
    box-shadow: 0 3px 6px 0 rgba(74, 143, 174, 0.91);
}

.img-user img {
    width: 165px;
    height: 194px;
}

.img-ktp {
    width: 165.2px;
    height: 194px;
    object-fit: contain;
    box-shadow: 0 3px 6px 0 rgba(74, 143, 174, 0.91);
}

.img-ktp img {
    width: 165.2px;
    height: 194px;
}

@media screen and (min-width: 768px) {
    .active {
        padding: 10px;
        text-align: center;
        font-size: 13px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .active::before {
        width: 28px;
        left: -25px;
    }
}

@media (max-width: 768px) {
    .container-outline {
        width: 90%;
    }

    li > span {
        display: none;
    }

    .form-input,
    select,
    .input-button {
        width: 100%;
    }

    .birtday,
    .kecamatan,
    .input-rt-rw {
        width: 100% !important;
        text-align: left;
    }

    .register {
        margin: 20px 0;
    }

    .title {
        font-size: 18px;
        margin: 0 0 20px;
    }

    .sub-title {
        margin-bottom: 20px;
    }

    .top-squence {
        width: 100%;
        padding: 15px 10px;
    }

    .container {
        width: 100%;
        padding: 25px 20px;
    }

    .identitas,
    .form-ktp-bagi,
    .tanggal-aktif,
    .tempat,
    .kecamatan,
    .input-rt-rw {
        margin: 0 0 10px;
    }

    .detail-alamat,
    .rt-rw {
        margin: 0 0 0.5rem;
        width: 10rem;
    }

    .form-group {
        display: flex;
        margin-bottom: 1rem;
    }

    .form-checkbox {
        align-items: flex-start;
    }

    .label--checkbox {
        position: inherit !important;
        margin-left: 15px;
    }

    label {
        width: 10rem;
        font-weight: bold;
    }

    .button {
        display: block;
        width: 100%;
        padding: 25px 20px;
        text-align: center;
    }

    .btn-scondary,
    .btn-primer {
        width: 100%;
    }

    .btn-scondary {
        margin-bottom: 20px;
    }

    .content-modal {
        width: 95%;
    }

    .wrap-document {
        width: 100%;
        padding: 30px 0;
    }

    .group-file {
        display: block;
    }

    .wrap-label {
        width: 100%;
    }

    .picture {
        margin-bottom: 55px;
    }

    .sub-sub-title {
        margin: unset;
        width: 100%;
    }
}
</style>
